
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/classification",
      function () {
        return require("private-next-pages/android/classification/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/classification"])
      });
    }
  